import { useQuery } from '@tanstack/react-query'

import { FetchGenericFormText } from '@/services/IntakeFormService'

/**
 * The text a generic intake form currently serves.
 *
 * Kept out of the cache once it is no longer on screen: the edit box reads it to
 * start from, and starting from a stale copy is the one thing that has to not
 * happen.
 */
export const useGenericFormText = (orgId: string, baseFormId: string) => {
  return useQuery({
    queryKey: ['genericFormText', orgId, baseFormId],
    queryFn: () => FetchGenericFormText(orgId, baseFormId),
    enabled: orgId !== '' && baseFormId !== '',
    gcTime: 0,
    staleTime: 0,
    // The box cannot be used at all until this settles, so a retry only extends
    // the shut-out. Its sibling sets this for the same reason on a milder case.
    retry: 0,
    // The box says so where the fields would be, so a toast on top would report
    // the same failure twice.
    meta: { suppressGlobalError: true },
  })
}
